import logo from "./logo.svg";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import { UniqueIdProvider } from "./FinContext";
import Routings from "./routes.js";
import { useIdleTimer } from './useIdleTimer';
import { EsignetClient} from "./auth/esignet.js";
import { RESET_ALL_STATES } from "./Redux/actions/actions.js";
import { persistor } from "./Redux/store";

const esignetClient = new EsignetClient();

function App() {
  useIdleTimer(() => esignetClient.logout(), 15 * 60 * 1000);
  return (
    <UniqueIdProvider>
      <BrowserRouter>
        <Routings />
      </BrowserRouter>
    </UniqueIdProvider>
  );
}

export default App;
